import { useContext } from 'react'
import { request } from 'graphql-request'
import { nanoid } from 'nanoid'
import { AppContext } from '@state/context'
import { addToast, removeToast } from '@state/actions/toastsAction'

const useApi = () => {
  const [, dispatch] = useContext(AppContext)

  const postMutation = async (
    data,
    mutation,
    successMessage,
    errorMessage,
    onSuccessCallback = null
  ) => {
    try {
      const res = await request('/graphql', mutation, data)
      console.log('postMutation success', res)

      if (onSuccessCallback) await onSuccessCallback()

      if (successMessage) {
        // toast success
        const toast = {
          id: nanoid(),
          message: successMessage,
        }
        addToastWithTimer(toast)
      }

      // return id where needed, on newly created items
      let id = null
      if (res.createSection) id = res.createSection.id
      if (res.createBook) id = res.createBook.id

      return { success: true, id: id, ...res }
    } catch (error) {
      console.log('postMutation error', error)

      if (errorMessage) {
        // toast error
        const toast = {
          id: nanoid(),
          message: errorMessage,
          error: true,
        }
        addToastWithTimer(toast)
      }

      return { success: false }
    }
  }

  const addToastWithTimer = (toast) => {
    dispatch(addToast(toast))

    setTimeout(() => {
      requestAnimationFrame(() => {
        dispatch(removeToast(toast.id))
      })
    }, 3000)
  }

  return {
    postMutation,
  }
}

export { useApi }
